import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { appInterceptor } from './core/interceptor/app.interceptor';
import { cacheInterceptor } from './core/interceptor/cache.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideRouter(routes),
    provideHttpClient(withInterceptors([appInterceptor, cacheInterceptor]))
  ]
};
